import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "../Common/withRouter"
import { Link } from "react-router-dom"

// i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [props.router.location.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">

            {/* ── OPERACIONES ── */}
            <li className="menu-title">{props.t("Operaciones")}</li>

            <li>
              <Link to="/portal" className="waves-effect">
                <i className="mdi mdi-view-dashboard-outline"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {/* ── GESTIÓN ── */}
            <li className="menu-title">{props.t("Gestión")}</li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-office-building-outline"></i>
                <span>{props.t("Empresa")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/consultar-empresas">
                    {props.t("Consultar Empresas")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-file-document-outline"></i>
                <span>{props.t("Comprobantes")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/consultar-comprobantes">
                    {props.t("Consultar Comprobantes")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/reporte-comprobantes">
                    {props.t("Reporte Comprobantes")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/reporte-faltantas">
                    {props.t("Folios Faltantes")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/analisis-ventas">
                    {props.t("Análisis de Ventas")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/medios-pagos">
                    {props.t("Medios de Pago")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/terceros">
                    {props.t("Terceros")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-calculator-variant-outline"></i>
                <span>{props.t("Impuestos")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/impuestos-generales">
                    {props.t("Impuestos Generales")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-package-variant-closed"></i>
                <span>{props.t("Inventarios")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/analisis-articulos">
                    {props.t("Análisis Artículos")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-bullhorn-outline"></i>
                <span>{props.t("Mercadeo")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/perfil-cliente">
                    {props.t("Perfil Cliente")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/mapa-consumo">
                    {props.t("Mapa de Consumo")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-email-fast-outline"></i>
                <span>{props.t("Envío de correos")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/envio-correos/analisis">
                    {props.t("Análisis")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/envio-correos/errores">
                    {props.t("Errores por emisor")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/envio-correos/reenvio-masivo">
                    {props.t("Reenvío masivo")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/envio-correos/bandeja">
                    {props.t("Bandeja de envíos")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/envio-correos/reportes">
                    {props.t("Reportes de entregabilidad")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-target"></i>
                <span>{props.t("Presupuestos")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/presupuestos">
                    {props.t("Mis presupuestos")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/presupuestos/nuevo">
                    {props.t("Nuevo presupuesto")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/presupuestos/comparativo">
                    {props.t("Comparativo vs Ventas")}
                  </Link>
                </li>
              </ul>
            </li>

            {/* ── ADMINISTRACIÓN ── */}
            <li className="menu-title">{props.t("Administración")}</li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-account-group-outline"></i>
                <span>{props.t("Usuarios")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/usuarios">
                    {props.t("Listar Usuarios")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/registro">
                    {props.t("Registrar Usuario")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="mdi mdi-shield-account-outline"></i>
                <span>{props.t("Seguridad")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/portal/roles">
                    {props.t("Roles y Permisos")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/menus">
                    {props.t("Gestión de Menús")}
                  </Link>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
